import { render, staticRenderFns } from "./RationPlans.vue?vue&type=template&id=5700e23e"
import script from "./RationPlans.vue?vue&type=script&lang=ts"
export * from "./RationPlans.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports